<template>
  <v-col cols="12" lg="3" sm="6">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text class="text-h6 font-weight-black"> Zona de residência </v-card-text>

      <apexchart v-if="hasData" height="100" :options="chartOptions" :series="series" />

      <div v-else class="d-flex align-center justify-center text-grey" style="height: 100px">
        Sem registros de zona de residência
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ZonaCard",

  props: {
    franquiaId: {
      default: null,
      type: Number,
    },
  },

  data() {
    return {
      chartOptions: {
        chart: {
          height: 400,
          offsetX: -20,
          type: "donut",
        },

        labels: ["Urbana", "Rural"],

        legend: {
          offsetX: -20,
        },

        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                width: 400,
              },

              legend: {
                offsetY: -80,
                position: "bottom",
              },
            },
          },
        ],
      },

      loading: false,

      series: [],
    };
  },

  computed: {
    hasData() {
      return this.series.some((value) => value > 0);
    },
  },

  watch: {
    franquiaId: {
      handler(value) {
        this.getZona(value);
      },

      immediate: true,
    },
  },

  methods: {
    async getZona(franquiaId) {
      if (!franquiaId) {
        this.series = [];
        return;
      }

      this.loading = true;

      try {
        const { data } = await this.$services.alunosService.zona(franquiaId);

        const values = Object.values(data ?? {});

        this.series = values.slice(0, 2).map((value) => Number(value) || 0);
      } catch (error) {
        console.error("Erro ao carregar dados de zona de residência:", error);
        this.series = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
